'use client';

import { IconButton } from '../../../../components/icon-button';
import { Tooltip } from '../../../../components/tooltip';
import { Box } from '@terra/ui-styled-system';
import { Link01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import type { WebAppSuggestedApplicationDto } from '@terra/shared-contracts-external-network';

type WebAppClusterMatchHintProps = {
  suggestion: WebAppSuggestedApplicationDto;
};

export function WebAppClusterMatchHint({
  suggestion,
}: WebAppClusterMatchHintProps) {
  const t = useTranslations(
    'designSystem.networkSettings.externalInventory.webApp',
  );
  const isDomainMatch = suggestion.matchReason === 'DOMAIN';
  const label = isDomainMatch ? t('matchedByDomain') : t('matchedByUrl');
  const explanation = isDomainMatch
    ? t('matchExplanationDomain', {
        appName: suggestion.name,
        hostname: suggestion.matchedHostname,
      })
    : t('matchExplanationUrl', {
        appName: suggestion.name,
        hostname: suggestion.matchedHostname,
      });

  return (
    <Tooltip title={explanation} positioning={{ strategy: 'fixed' }}>
      <IconButton variant="ghost" size="xs" aria-label={label} flexShrink={0}>
        <Box color="fg.success">
          <Link01Icon size={16} color="currentColor" />
        </Box>
      </IconButton>
    </Tooltip>
  );
}
